
const url_backend = true ? "https://rest.sign-tech.org" : "http://localhost:3000" // true = production

export const url_base = `${url_backend}/api/v1`

export const url_status = `${url_base}/status`
export const url_role = `${url_base}/role`
export const url_tag = `${url_base}/tag`
export const url_category = `${url_base}/category`
export const url_contact = `${url_base}/contact`
export const url_gallery = `${url_base}/gallery`
export const url_word = `${url_base}/word`
export const url_user = `${url_base}/user`